module.exports = __webpack_public_path__ + "staticcomp/img/share.9a7d6de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/4/share.jpg
// module id = Nc2Y
// module chunks = 39